import { parseQueryString } from './parseQueryString';

/**
 * When no 'q' is present in the URL, we return an empty string which is
 * convenient for the input value.
 * @type {string}
 */
const fallback = '';

/**
 *
 * @param queryString
 * @returns {string | undefined}
 */
export default function getSearchQueryFromQueryString(queryString) {
  return parseQueryString(queryString).q || fallback;
}
